module.exports = __webpack_public_path__ + "static/media/mastersinfinance.b1ee14de.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mastersinfinance.webp
// module id = 485
// module chunks = 0